import React from "react";

import { ReactComponent as ImageIcon } from "static/images/image-icon.svg";
import styles from "./addLogo.module.scss";

type zoomRangeProps = {
	zoom: number;
	setZoom: Function;
};

const ZoomRange = ({ zoom, setZoom }: zoomRangeProps) => {
	const getBackgroundSize = () => {
		return { backgroundSize: `${((zoom - 1) * 100) / 2}% 100%` };
	};

	return (
		<div className={styles.containerRange}>
			<ImageIcon style={{ width: "27px" }} />
			<input
				type="range"
				value={zoom}
				min={1}
				max={3}
				step={0.1}
				aria-labelledby="Zoom"
				onChange={e => {
					setZoom(e.target.value);
				}}
				style={getBackgroundSize()}
				className={styles.zoomRange}
			/>
			<ImageIcon />
		</div>
	);
};

export default ZoomRange;
